import React from 'react';
import PropTypes from 'prop-types';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { PAGE_TITLES } from '@/constants/appConfig';
import {
  FullScreenErrorContainer,
  ErrorDetails,
} from './styles/ErrorPage.styles';

/**
 * NetworkError Component
 * Displays when the application fails to connect to the backend
 * This is a full-screen error meant for critical connection failures
 *
 * @component
 * @param {Object} props - Component props
 * @param {Object} props.error - Error object containing details about the network failure
 * @return {JSX.Element} Network error page
 */
const NetworkError = ({ error }) => {
  document.title = PAGE_TITLES.NETWORK_ERROR;

  return (
    <FullScreenErrorContainer>
      <section>
        <h3>
          <ExclamationCircleOutlined /> Unable to connect.
        </h3>
        <ErrorDetails>Error details: {error.message}</ErrorDetails>
      </section>
    </FullScreenErrorContainer>
  );
};

NetworkError.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string.isRequired,
  }).isRequired,
};

export default NetworkError;
